/* eslint-disable i18next/no-literal-string */
import styles from './Divider.module.scss';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const Divider = props => {
    return (
        <li
            data-testid="navbar.divider"
            className={['govuk-header__navigation-item', styles.divider].join(' ')}
            { ...props }
            role="menuitem"
            aria-hidden={'true'}
        >
            |
        </li>
    );
};

Divider.propTypes = {
    ...defaultAriaProps
};

export default Divider;
